"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PurchaseCommand = void 0;
class PurchaseCommand {
    constructor(input) {
        this.input = input;
    }
    execute(config) {
        const { value, contents, currency, transaction_id } = this.input;
        const { gtag: googleAnalyst } = config;
        googleAnalyst('event', 'purchase', {
            currency: currency,
            value: value,
            transaction_id: transaction_id,
            items: contents?.map(content => ({
                item_id: content.id,
                quantity: content.quantity,
                google_business_vertical: 'retail'
            })) ?? []
        });
        return Promise.resolve();
    }
}
exports.PurchaseCommand = PurchaseCommand;
